// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");

function CheckboxInput(props) {
  var __labelClassName = props.labelClassName;
  var __checkboxClassName = props.checkboxClassName;
  var __className = props.className;
  var __indeterminate = props.indeterminate;
  var __disabled = props.disabled;
  var disabled = __disabled !== undefined ? __disabled : false;
  var indeterminate = __indeterminate !== undefined ? __indeterminate : false;
  var className = __className !== undefined ? __className : "";
  var checkboxClassName = __checkboxClassName !== undefined ? __checkboxClassName : "checkbox";
  var labelClassName = __labelClassName !== undefined ? __labelClassName : "text-base leading-normal sm:-mt-1 whitespace-normal";
  var domElement = React.useRef(null);
  React.useEffect((function (param) {
          var y = Belt_Option.getExn(Caml_option.nullable_to_opt(domElement.current));
          y.indeterminate = indeterminate;
        }), []);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("label", {
                      children: [
                        JsxRuntime.jsx("input", {
                              ref: Caml_option.some(domElement),
                              checked: indeterminate ? false : props.checked,
                              disabled: disabled,
                              type: "checkbox",
                              onChange: props.handleChange
                            }),
                        JsxRuntime.jsx("div", {
                              className: disabled ? "disabled-input cursor-not-allowed " + checkboxClassName : "cursor-pointer " + checkboxClassName
                            })
                      ]
                    }),
                JsxRuntime.jsx("div", {
                      children: props.label,
                      className: disabled ? labelClassName + " cursor-not-allowed" : labelClassName
                    })
              ],
              className: "flex gap-2 items-start " + className
            });
}

var make = CheckboxInput;

exports.make = make;
/* react Not a pure module */
